import { render, staticRenderFns } from "./WorkingPointModel.vue?vue&type=template&id=12448362&scoped=true"
import script from "./WorkingPointModel.vue?vue&type=script&lang=js"
export * from "./WorkingPointModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12448362",
  null
  
)

export default component.exports